<template>
    <div>
        <!-- 面包屑导航 -->
        <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
        <div class="content" style="padding-bottom:24px !important;">
            <h2>结算金管理</h2>
            <h3>数据筛选</h3>
            <div>
                <el-form :inline="true" :model="searchForm" ref="search" class="search-form" size="small">
                    <el-form-item label="用户ID" prop="userId">
                        <el-input v-model="searchForm.userId" placeholder="请输入用户ID" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="用户昵称" prop="nickName">
                        <el-input v-model="searchForm.nickName" placeholder="请输入用户昵称"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码" prop="phone">
                        <el-input v-model="searchForm.phone" placeholder="请输入手机号码" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="用户等级" prop="vipId">
                        <el-select v-model="searchForm.vipId" placeholder="请选择用户等级" filterable clearable>
                            <el-option v-for="item in dictionaries.platform_vip_level" :key="item.dictId"
                                :label="item.dictName" :value="item.dictId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="平台" prop="platformId">
                        <el-select style="width: 215px" v-model="searchForm.platformId" placeholder="请选择平台" filterable
                            clearable>
                            <el-option v-for="item in platformList" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="fetchData('search')">查询</el-button>
                        <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="content">
            <div class="title">
                <h3>列表数据</h3>
                <div>
                    <el-button type="primary" @click="deriveDeliver">导出</el-button>
                </div>
            </div>
            <div id="base-list">
                <lb-table v-loading="loading" v-horizontal-scroll="'always'" :column="columns" :data="settlementList"
                    pagination :total="page.totalNum" layout="total, sizes, prev, pager, next, jumper"
                    :page-sizes="[5, 10, 20, 30, 50]" :current-page.sync="searchForm.pageNo"
                    :page-size="searchForm.pageSize" @selection-change="onMultipleSelection" @size-change="handleSizeChange"
                    @p-current-change="handleCurrentChange">
                </lb-table>
            </div>
        </div>
    </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
    components: {
        breadcrumbTop,
        LbTable
    },
    data() {
        return {
            dataList: {
                list: [
                    { title: '矩阵管理', path: '', type: '0' },
                    { title: '结算金管理', path: '', type: '1' }
                ]
            },
            searchForm: {
                userId: '',
                nickName: '',
                phone: '',
                vipId: '',
                platformId: '',
                pageNo: 1,
                pageSize: 10
            },
            loading: false,
            columns: [
                { type: 'selection', minWidth: '80', fixed: 'left' },
                { label: '用户ID', prop: 'userId', minWidth: '90' },
                { label: '用户昵称', prop: 'nickName', minWidth: '200' },
                { label: '手机号码', prop: 'phone', minWidth: '100' },
                { label: '用户等级', prop: 'vipLevelName', minWidth: '120' },
                { label: '平台', prop: 'platformName', minWidth: '200' },
                { label: '待结算金额', prop: 'awaitSettlementAmount', minWidth: '120' },
                { label: '可提现金额', prop: 'withdrawSettlementAmount', minWidth: '120' },
                { label: '已提现金额', prop: 'paidSettlementAmount', minWidth: '200' },
                {
                    label: '操作',
                    minWidth: '120',
                    fixed: 'right',
                    render: (h, scope) => {
                        return (
                            <div>
                                <span style='color:#4168E7;cursor:pointer' onClick={() => { this.todetail(scope.row) }}>查看</span>
                            </div >
                        )
                    }
                }
            ],
            page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
            selectionGoods: [],
            dictionaries: {},
            platformList: [],
            settlementList: []
        }
    },
    created() {
        this.getDictionaries('platform_vip_level')
        this.goodsPlatforms()
        this.getList()
    },
    methods: {
        //导出
        deriveDeliver() {
            this.axios.post('/ps/platforms/settlement/export', this.searchForm)
                .then(res => {
                    if (res.code == 0) {
                        this.downloadlink(res.data)
                        this.$message({
                            type: 'success',
                            message: '导出成功!'
                        })
                    }
                })

        },
        downloadlink(url) {
            const iframe = document.createElement('iframe')
            iframe.style.display = 'none'
            iframe.src = url
            document.body.appendChild(iframe)
        },
        fetchData(type) {

            if (type == 'reset') {
                this.page.pageNo = 1;
                this.searchForm.pageNo = 1;
                this.$refs['search'].resetFields()
            } else if (type == 'search') {
                this.page.pageNo = 1;
                this.searchForm.pageNo = 1;
            }
            console.log(this.searchForm.pageNo)
            this.getList()
        },
        getList() {
            this.axios.post('/ps/platforms/settlement/list', this.searchForm)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        res.data.list.forEach(item => {
                            item.awaitSettlementAmount = item.awaitSettlementAmount.toFixed(2)
                            item.withdrawSettlementAmount = item.withdrawSettlementAmount.toFixed(2)
                            item.paidSettlementAmount = item.paidSettlementAmount.toFixed(2)
                        });
                        this.settlementList = res.data.list;
                        this.page.totalNum = res.data.totalNum;
                    }
                })
        },
        //获取平台列表
        goodsPlatforms() {
            const params = {
                userId: null,
                username: null,
                phone: null,
                vipLevel: null,
                categoryIds: null,
                openTimeStart: null,
                openTimeEnd: null,
                status: 1
            }
            this.$api.goodsPlatforms(params).then((res) => {
                console.log(res)
                this.platformList = res.data
            }).catch((err) => {
                console.log(err)
            })
        },
        // 获取字典数据
        getDictionaries(type) {
            const params = { groupId: type }
            this.$api.dictionaries(params).then((res) => {
                this.dictionaries['platform_vip_level'] = res.data
                this.$forceUpdate()
            }).catch((err) => {
                console.log(err)
            })
        },
        onMultipleSelection(val) {
            this.selectionGoods = val
        },
        handleCurrentChange(currentChange) {
            this.searchForm.pageNo = currentChange
            this.page.pageNo = currentChange
            this.fetchData()
        },
        handleSizeChange(sizeChange) {
            this.searchForm.pageSize = sizeChange
            this.page.pageSize = sizeChange
            this.fetchData()
        },
        todetail(row) {
            this.$router.push({
                name: 'platformSettlementFund',
                query: {
                    platformId: row.platformId
                }
            })
        }
    }
}
</script>
<style scoped lang="scss">
.search-form {
    display: flex;
    flex-wrap: wrap;

    .el-form-item {
        /deep/ .el-form-item__label {
            width: 82px;
            text-align: right;
            vertical-align: middle;
            float: left;
            box-sizing: border-box;
        }

        /deep/ .el-form-item__content {
            display: block;
            margin-left: 82px;

            .el-cascader,
            .el-select {
                width: 100%;
            }
        }
    }
}

.title {
    display: flex;
    justify-content: space-between;
}

#base-list {
    margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
    display: inline-block;

    a {
        margin: 0 5px;
    }
}
</style>